module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter10",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400187_line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("I’M NOT SURE")]), _vm._v(" if anyone sits down one day and says, “I think I’ll write a cookbook.” Of course, I could be wrong. In the beginning, this book was about my local area, a view from my mountain “holler.” It’s been fortunate that I’ve had numerous people telling me stories, sharing recipes, and cheering me on, and as a result, what started out as a little book has grown to include all of southern Appalachia. Upon hearing of the book, folks talked to me as if I were their southern kin: “Ya’ll have to go here” or “Ya’ll have to talk to. …” The joy with which they share their heritage and their friendly spirit is part of what makes this region so special.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lane Butler: No one writes a book alone, and it’s the editor’s job to make it all come together. That, Lane did beautifully. Her real talent lies in being able to communicate with an author and gently guide him or her along a set path. I’m not sure she’ll ever know just how much I appreciate her and her guidance. My vision became her vision, and somewhere in the process of creating this book, it blossomed into something much grander than I had originally conceived. For that, and for so much more, I thank and acknowledge her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara Ward Land: One of my neighbors as the crow flies and a native southern Appalachian, Barb is a trained pastry chef and an accomplished cook. A busy woman, she not only contributed to the book, but also put up with my popping up at any given moment, usually where she was working, asking her questions about certain recipes. She never failed to graciously help me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Ward: Larry is a fifth-generation woodworker and carver here in the southern Appalachian Mountains. His family has been featured in major works on the area, and Larry can tell you anything you’d want to know about the southern Appalachian culture. He once told me that “outsiders aren’t going to find us by hanging out in town. They need to get out and talk to local folks.” Larry is an outrageous storyteller and is responsible for the recipe for homemade Appalachian wines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robert Grannis: My friend Bob has been supportive and encouraging from the beginning. While I was sitting in the winter cold, he never failed to tell me the temperature in Florida. Ha! We share the belief that all cultures are valuable and should be honored, and I’ve attempted to do that in this book. No place is made up of just one kind of people, and we often overlook the contributions made and the shared histories. The gathering of different cultures gives southern Appalachia its unique flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400187_vii-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Errol Dillon: Errol, my Mississippi friend, encouraged my photography.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John C. Rivers: My southern Appalachian friend from Alabama, J.C. has contributed to the book by giving me his recipes and sharing his expertise on soul food. His family has been in the area since slavery and his knowledge of history and local sites is invaluable. His encouragement and contributions to the book have been gratefully received.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bed-and-breakfast inns: I would also like to acknowledge the bed-and-breakfast inn owners and chefs who contributed to the book. Although I haven’t yet met many of them in person, I found them to be warm and positive folks who did not hesitate to participate when asked. Some of them are native southern Appalachians and others have chosen the region as their home. They shared family recipes and stories along with their insights into the area.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400187_viii-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13976874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400187_epub_ack_r1.vue
// module id = 78
// module chunks = 0